import adserver, { AxiosError } from 'services/adserver';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { basketsKeys } from './baskets.keys';

export type BasketStatusGroupsSummary = Record<string, number>;

type BasketSummaryObjectItem = {
  statusGroup?: string;
  id?: string;
  count?: number;
  total?: number;
};

type BasketSummaryResponse =
  | BasketStatusGroupsSummary
  | BasketSummaryObjectItem[];

const getCampaignBasketsSummary = async (
  campaignId: string | number,
): Promise<BasketSummaryResponse> => {
  const { data } = await adserver({
    url: `/campaign/${campaignId}/baskets/summary`,
    method: 'GET',
    headers: {},
  });

  return data;
};

const normalizeBasketSummary = (
  data: BasketSummaryResponse,
): BasketStatusGroupsSummary => {
  return Object.entries(data).reduce<BasketStatusGroupsSummary>(
    (acc, [key, value]) => {
      acc[key] = Number(value);
      return acc;
    },
    {},
  );
};

export const useGetCampaignBasketsSummary = (
  campaignId: string | number,
): UseQueryResult<BasketStatusGroupsSummary, AxiosError> =>
  useQuery<BasketSummaryResponse, AxiosError, BasketStatusGroupsSummary>({
    queryKey: basketsKeys.summary(campaignId),
    queryFn: () => getCampaignBasketsSummary(campaignId),
    enabled: !!campaignId,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    select: normalizeBasketSummary,
  });
